// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1wie3","left":"StickyBox_left__1Qbg9","right":"StickyBox_right__PzV6q"};